<template>
  <div class="menu-basket" @click="handlerClick">
    <svg class="menu-basket__icon"><use xlink:href="#svg-basket"></use></svg>
    <span class="menu-basket__text">
      {{ basket.messages.basket }}
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from '@store';
import useBasketState from '@use/useBasketState';

const { state, commit } = useStore();
const basket = computed(() => state.basket.data);
const basketState = useBasketState();

const handlerClick = () => {
  if (basket.value?.count > 0) {
    basketState.open();
  }
};
</script>

<script>
export default {
  name: 'MenuBasket',
};
</script>

<style lang="scss" scoped>
.menu-basket {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  font-size: rem(16);
  line-height: 125%;
  color: var(--color-main);
  &__icon {
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
  &__text {
    transform: translateY(1px);
  }
}
</style>
